module.exports = __webpack_public_path__ + "img/motors-logo.81549feb.png";